let uniqid = +new Date();

export const writeTempStyleTag = (cssString) => {
	const id = `stag-temp-${ uniqid++ }`;
	const tag = document.createElement('style');
	tag.id = id;
	tag.innerText = cssString;
	document.head.appendChild(tag);
	return tag;
};

/**
 * An IOS safe viewport height.
 *
 * @return {number} Current height of the window.
 */
export const viewportHeight = () =>
	Math.max(
		document.documentElement.clientHeight || 0,
		window.innerHeight || 0
	);

/**
 * An IOS safe viewport width.
 *
 * @return {number} Current width of the window.
 */
export const viewportWidth = () =>
	Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

/**
 * Adds the current height as a css var.
 * --window-sync-height
 * Usually used to help overcome IOS viewport size changes on scroll.
 */
export const syncHeight = () => {
	document.documentElement.style.setProperty(
		'--window-sync-height',
		`${viewportHeight()}px`
	);
};